<template>
  <v-card-subtitle>
    <slot />
  </v-card-subtitle>
</template>
